var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { vaultUtils, vaultData } from "@zetamarkets/flex-sdk";
import { defaultSolanaVaultData } from "../models/vault";
import { BigNumber } from "@ethersproject/bignumber";
import { useFlexVault } from "./useFlexVault";
import { getUserDepositQueueAmount, getUserWithdrawQueueAmount, } from "../utils/vault";
var useFetchSolVaultData = function () {
    var connection = useConnection().connection;
    var _a = useFlexVault(), vault = _a.vault, client = _a.client;
    var publicKey = useWallet().publicKey;
    var _b = useState(), data = _b[0], setData = _b[1];
    useEffect(function () {
        var doMulticall = function () { return __awaiter(void 0, void 0, void 0, function () {
            var vaultAddress, _a, depositLimit, epochSequenceNumber, totalBalance, pricePerShare, lockedBalanceInAsset, depositBalanceInAsset, totalQueuedWithdrawals, totalQueuedDeposits;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Should always set loading to false when no vault and no conection
                        if (!vault || !connection) {
                            setData(__assign(__assign({}, defaultSolanaVaultData), { loading: false }));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, vaultUtils.getVaultAddress("rSOL-THETA")];
                    case 1:
                        vaultAddress = (_b.sent())[0];
                        return [4 /*yield*/, vaultData.getVaultData(connection, vaultAddress)];
                    case 2:
                        _a = _b.sent(), depositLimit = _a.depositLimit, epochSequenceNumber = _a.epochSequenceNumber, totalBalance = _a.totalBalance, pricePerShare = _a.pricePerShare;
                        lockedBalanceInAsset = BigNumber.from(0);
                        depositBalanceInAsset = BigNumber.from(0);
                        totalQueuedWithdrawals = BigNumber.from(0);
                        totalQueuedDeposits = BigNumber.from(vault.totalQueuedDeposits);
                        if (publicKey) {
                            totalQueuedWithdrawals = getUserWithdrawQueueAmount(vault, publicKey);
                            depositBalanceInAsset = getUserDepositQueueAmount(vault, publicKey);
                            lockedBalanceInAsset = BigNumber.from(0);
                            // if (client) {
                            //   lockedBalanceInAsset = BigNumber.from(
                            //     client.getRedeemableTokenAmount(
                            //       getSolanaVaultInstance("rSOL-THETA")
                            //     ) || 0
                            //   );
                            // }
                        }
                        setData({
                            responses: {
                                "rSOL-THETA": {
                                    totalBalance: BigNumber.from(totalBalance).add(totalQueuedDeposits),
                                    cap: BigNumber.from(depositLimit),
                                    pricePerShare: BigNumber.from(0),
                                    // pricePerShare: pricePerShare
                                    //   ? parseUnits(
                                    //       pricePerShare.toFixed(getAssetDecimals("SOL")),
                                    //       getAssetDecimals("SOL")
                                    //     )
                                    //   : BigNumber.from(0),
                                    round: epochSequenceNumber,
                                    // user-connected state
                                    lockedBalanceInAsset: lockedBalanceInAsset,
                                    depositBalanceInAsset: BigNumber.from(depositBalanceInAsset),
                                    withdrawals: {
                                        round: BigNumber.from(totalQueuedWithdrawals).isZero()
                                            ? 0
                                            : epochSequenceNumber,
                                        shares: BigNumber.from(totalQueuedWithdrawals),
                                    },
                                },
                            },
                            loading: false,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        doMulticall();
    }, [publicKey, vault, client, connection]);
    return data || defaultSolanaVaultData;
};
export default useFetchSolVaultData;
//# sourceMappingURL=useFetchSolVaultData.js.map